import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getFirmwaresTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'name',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.name',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'modelCount',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.modelCount',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'version',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.version',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'comment',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.comment',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'uploadedBy',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.uploadedBy',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'uploadDate',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.uploadDate',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'download',
    captionTranslateKey: 'monitoring.firmware.dashboard.col.download',
    type: TableColumnTypeEnum.Actions,
    colClass: 'firmware__th--actions',
  },
];
